import {
  CONTENT_SEPARATOR,
  DETAILS_CONTENT_KEYS,
  IPlanContent,
  PLAN_DETAILS_EXIT_FEES,
  PLAN_DETAILS_KEY,
  PLAN_DETAILS_PLAN_PERIOD,
  PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
  PLAN_DETAILS_RATE_TYPE,
} from '../../typings';
import { createPlanNameMatcher, getKeyDetailsContentIcon } from '../utils/PlanMetaHelper';
import { PlanKeyDetailsModal } from '../common/PlanKeyDetailsModal';
import {
  defaultEstimatesDialog,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
  gasKeyDetailsAddons,
} from '../common/planDefaults';

export const gasSignupOptions = [
  'Direct debit optional for hassle-free bill payments',
  'Inbox or letterbox? Your choice for letters and bills',
];

export const defaultSignupOptions = [
  gasSignupOptions[0],
  'Your electricity billed monthly or quarterly',
  gasSignupOptions[1],
];

export const defaultHSKeyDetails = [
  {
    contentKey: DETAILS_CONTENT_KEYS.Rates,
    contentValue: 'Variable',
    modalContent: PlanKeyDetailsModal,
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
    contentDescription: 'Variable rates',
  },
  {
    contentKey: DETAILS_CONTENT_KEYS.ExitFees,
    contentValue: 'No',
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
    contentDescription: 'No exit fees. Leave anytime.',
  },
  {
    contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
    contentValue: '12 months' + CONTENT_SEPARATOR + PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
    contentDescription: '12 month benefit period',
  },
  {
    contentKey: DETAILS_CONTENT_KEYS.Extras,
    contentValue:
      'Up to $300 (incl GST) available for max 2 emergency home callouts in the Energy Plan period. 24/7 access to AGA’s support line and qualified tradespeople network.',
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Extras),
    contentDescription:
      'Up to $300 (incl GST) available for max 2 emergency home callouts in the Energy Plan period. 24/7 access to AGA’s support line and qualified tradespeople network.',
    isText: true,
  },
];

export const defaultHSPlanDetails = [
  {
    contentKey: PLAN_DETAILS_KEY.RateType,
    contentValue: PLAN_DETAILS_RATE_TYPE.Flexible,
  },
  {
    contentKey: PLAN_DETAILS_KEY.ExitFees,
    contentValue: PLAN_DETAILS_EXIT_FEES.None,
  },
  {
    contentKey: PLAN_DETAILS_KEY.PlanPeriod,
    contentValue:
      PLAN_DETAILS_PLAN_PERIOD.Months12 + CONTENT_SEPARATOR + PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
  },
];

export const dualHSKeyDetails = [
  ...defaultHSKeyDetails.slice(0, 3),
  {
    contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
    contentValue:
      '12 months for Origin Home Support, ongoing for Origin Basic' +
      CONTENT_SEPARATOR +
      PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
    contentDescription: '12 months for Origin Home Support, ongoing for Origin Basic.',
    isText: true,
  },
  ...defaultHSKeyDetails.slice(4),
];

export const dualHSPlanDetails = [
  ...defaultHSPlanDetails.slice(0, 3),
  {
    contentKey: PLAN_DETAILS_KEY.PlanPeriod,
    contentValue: '12 months for Origin Home Support, ongoing for Origin Basic',
  },
  ...defaultHSPlanDetails.slice(4),
];

export const homeSupportContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Home Support']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 12 month benefit period',
      },
    },
    keyFeatures: {
      defaultState: {
        defaultFuel: [
          'Up to $300 incl GST towards each callout (includes 2 callouts)',
          '24/7 access to qualified tradespeople in the Allianz network',
          'Support for 10 common home emergencies',
        ],
      },
    },
    signUpOptions: {
      defaultState: {
        defaultFuel: defaultSignupOptions,
        gas: gasSignupOptions,
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: defaultHSKeyDetails,
        dual: dualHSKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        gas: gasKeyDetailsAddons,
        dual: dualKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'grey',
              odsCore: 'neutral',
            },
            promobox: {
              styleGuide: 'lightOrange',
              odsCore: 'caution',
            },
            bannerText: {
              styleGuide: 'grey56',
              odsCore: 'grey600',
            },
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: 'Up to $300 (incl GST)  towards each emergency home callout (max 2)',
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
  },
};
